var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.99988 9.35991C10.9315 9.35991 12.497 7.74835 12.497 5.75991C12.497 3.77147 10.9315 2.15991 8.99988 2.15991C7.06826 2.15991 5.50274 3.77147 5.50274 5.75991C5.50274 7.74835 7.06826 9.35991 8.99988 9.35991ZM11.4479 10.2599H10.9916C10.3851 10.5468 9.71024 10.7099 8.99988 10.7099C8.28953 10.7099 7.61742 10.5468 7.00815 10.2599H6.55188C4.52463 10.2599 2.87988 11.953 2.87988 14.0399V15.2099C2.87988 15.9552 3.46729 16.5599 4.19131 16.5599H13.8085C14.5325 16.5599 15.1199 15.9552 15.1199 15.2099V14.0399C15.1199 11.953 13.4751 10.2599 11.4479 10.2599Z",
    fill: "#0075BC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/userProfile.5cc0b823d2a03b89191a7947bae4322a.svg";
export { ForwardRef as ReactComponent };